export const ageMethod = "age nearest";
export const gateway = "https://mello-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/mello";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJtZWxsbyIsIm5hbWUiOiJtZWxsbyIsImlhdCI6MTc3OTkyNDYwNCwiZXhwIjoxOTM3NzEyNjA0fQ.kclSWPyV3RYY33eDJOGs5Y9b-f6OFEHm97UZ-MF8_M4";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"mello.link.wawanesalife.com": {
		a: {
			approve_company: "CENTRAL",
			approve_user: "link_mello",
			brands: [
				"mello.link.wawanesalife.com",
			],
			broker: "mello",
			broker_formatted_name: "Mello Insurance",
			email: "kayla@melloinsurance.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "306-283-1236",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
				"photo5.jpg",
				"photo6.jpg",
			],
			privacyLink: "https://melloinsurance.ca/privacy-policy/",
			tagline: "Stay Mello",
			website: "https://melloinsurance.ca/",
			scope: "mello#branding#mello.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "mello.link.wawanesalife.com",
		},
		b: {
			approve_company: "CENTRAL",
			approve_user: "link_mello",
			brands: [
				"mello.link.wawanesalife.com",
			],
			broker: "mello",
			broker_formatted_name: "Mello Insurance",
			email: "kayla@melloinsurance.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "306-283-1236",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
				"photo5.jpg",
				"photo6.jpg",
			],
			privacyLink: "https://melloinsurance.ca/privacy-policy/",
			tagline: "Stay Mello",
			website: "https://melloinsurance.ca/",
			scope: "mello#branding#mello.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "mello.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 18:30:04 GMT-0500 (Central Daylight Time)
